import { render, staticRenderFns } from "./SortCategory.vue?vue&type=template&id=b34de7ae&scoped=true&"
import script from "./SortCategory.vue?vue&type=script&lang=js&"
export * from "./SortCategory.vue?vue&type=script&lang=js&"
import style0 from "./SortCategory.vue?vue&type=style&index=0&id=b34de7ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34de7ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
